/* StatsSection.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { media } from '@atlaskit/primitives';
import { H2 } from '@atlassian/mpac-primitives';
import React, { useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';

// Animated Counter Component
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _78 = "@media (min-width:64rem){._dm251ule{display:block}._13wnstnw{position:absolute}._hyzqcs5v{z-index:2}._gltezih3{width:353.337px}._165t4o5j{height:360.804px}._bb41gbua{aspect-ratio:1/1}._1t06utlk{inset-inline-end:max(-5pc,calc(50vw - 680px))}._180kdx5h{inset-block-start:var(--_3j0cp8)}}";
const _77 = "._1e0cglyw{display:none}";
const _76 = "@media (min-width:64rem){._dm25glyw{display:none}}";
const _75 = "@media (min-width:48rem) and (max-width:63.99rem){._1vkh68cl{height:90pt}._98081jfw{-webkit-margin-before:var(--ds-space-500,40px);margin-block-start:var(--ds-space-500,40px)}._qtemidpf{-webkit-margin-after:0;margin-block-end:0}._19vu1y6m{align-items:flex-start}}";
const _74 = "@media not all and (min-width:48rem){._tnrudlvw{height:210px}._476d1jfw{-webkit-margin-before:var(--ds-space-500,40px);margin-block-start:var(--ds-space-500,40px)}._srwzidpf{-webkit-margin-after:0;margin-block-end:0}._ag851y6m{align-items:flex-start}}";
const _73 = "._152tidpf{inset-block-start:0}";
const _72 = "._u7coidpf{inset-block-end:0}";
const _71 = "._rjxpidpf{inset-inline-end:0}";
const _70 = "._1h1tgbua{aspect-ratio:1/1}";
const _69 = "._1bah1h6o{justify-content:center}";
const _68 = "._1wyb1wto{font-size:3rem}";
const _67 = "._4t3i1osq{height:100%}";
const _66 = "._1bsbyh40{width:2px}";
const _65 = "._11q71fxt{background:var(--ds-text,#172b4d)}";
const _64 = "._bozgv47k{-webkit-padding-start:var(--ds-space-250,20px);padding-inline-start:var(--ds-space-250,20px)}";
const _63 = "@media not all and (min-width:48rem){._1fe7kb7n{flex-grow:1}._12ihkb7n{flex-shrink:1}._1a1xf1ug{flex-basis:0%}._chtuidpf{-webkit-padding-end:0;padding-inline-end:0}}";
const _62 = "._y4ti1jfw{-webkit-padding-end:var(--ds-space-500,40px);padding-inline-end:var(--ds-space-500,40px)}";
const _61 = "._2lx21bp4{flex-direction:column}";
const _60 = "._zulpv47k{gap:var(--ds-space-250,20px)}";
const _59 = "._i0dl1r5k{flex-basis:30%}";
const _58 = "._syaz1fxt{color:var(--ds-text,#172b4d)}";
const _57 = "._vwz419ii{line-height:1.4}";
const _56 = "._k48p1nn1{font-weight:400}";
const _55 = "._1wyb1j6v{font-size:1rem}";
const _54 = "@media (min-width:48rem) and (max-width:63.99rem){._1lzo12bs{font-size:4rem}}";
const _53 = "@media not all and (min-width:48rem){._1cqs1k7u{font-size:3.5rem}}";
const _52 = "._1wyb1lev{font-size:5rem}";
const _51 = "._syaz1e6v{color:var(--ds-text-brand,#0c66e4)}";
const _50 = "._vwz4kb7n{line-height:1}";
const _49 = "._k48p9y44{font-weight:800}";
const _48 = "._ect41roz{font-family:var(--ds-font-family-brand-heading,\"Charlie Display\",ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const _47 = "._18s8pn2k{margin:var(--_senhmo)}";
const _46 = "._18u0idpf{margin-left:0}";
const _45 = "._2hwxidpf{margin-right:0}";
const _44 = "@media not all and (min-width:48rem){._1fe7kb7n{flex-grow:1}._12ihkb7n{flex-shrink:1}._1a1xf1ug{flex-basis:0%}._1rfm1osq{width:100%}}";
const _43 = "._i0dl1ssb{flex-basis:50%}";
const _42 = "._1o9zkb7n{flex-shrink:1}";
const _41 = "._16jlkb7n{flex-grow:1}";
const _40 = "@media (min-width:48rem) and (max-width:63.99rem){._1os2idpf{flex-grow:0}._8os5idpf{flex-shrink:0}._16xt1osq{flex-basis:100%}._1gzv1ejb{gap:var(--ds-space-300,24px)}}";
const _39 = "@media not all and (min-width:48rem){._1gde1bp4{flex-direction:column}._1u2qoahv{-webkit-padding-before:var(--ds-space-600,3pc);padding-block-start:var(--ds-space-600,3pc)}}";
const _38 = "@media (min-width:48rem){._1t19idpf{flex-grow:0}._p7vbidpf{flex-shrink:0}._1rhg1w8u{flex-basis:80%}._19wgv47k{gap:var(--ds-space-250,20px)}}";
const _37 = "._4cvr1y6m{align-items:flex-start}";
const _36 = "._p12f1osq{max-width:100%}";
const _35 = "._1q51xy5q{-webkit-padding-before:var(--ds-space-400,2pc);padding-block-start:var(--ds-space-400,2pc)}";
const _34 = "._zulp1jfw{gap:var(--ds-space-500,40px)}";
const _33 = "@media (min-width:48rem) and (max-width:63.99rem){._55br1bp4{flex-direction:column}}";
const _32 = "@media not all and (min-width:48rem){._1gde1bp4{flex-direction:column}}";
const _31 = "._85i5v47k{-webkit-padding-after:var(--ds-space-250,20px);padding-block-end:var(--ds-space-250,20px)}";
const _30 = "._1q51v47k{-webkit-padding-before:var(--ds-space-250,20px);padding-block-start:var(--ds-space-250,20px)}";
const _29 = "._1e0c1txw{display:flex}";
const _28 = "._p12f1fra{max-width:75pc}";
const _27 = "._1yt410dx{padding:var(--_vzwnpz)}";
const _26 = "@media (min-width:48rem) and (max-width:63.99rem){._h15ztfdx{-webkit-clip-path:polygon(0 0,100% 6%,100% 90%,0 100%);clip-path:polygon(0 0,100% 6%,100% 90%,0 100%)}._qtem1jfw{-webkit-margin-after:var(--ds-space-500,40px);margin-block-end:var(--ds-space-500,40px)}}";
const _25 = "@media not all and (min-width:48rem){._1kmxidpf{padding-top:0}._1ggmidpf{padding-right:0}._1ykzidpf{padding-bottom:0}._1maeidpf{padding-left:0}._1vthtfdx{-webkit-clip-path:polygon(0 0,100% 6%,100% 90%,0 100%);clip-path:polygon(0 0,100% 6%,100% 90%,0 100%)}._srwz1jfw{-webkit-margin-after:var(--ds-space-500,40px);margin-block-end:var(--ds-space-500,40px)}}";
const _24 = "._mkrz13pj{-webkit-clip-path:polygon(0 0,86% 3%,86% 6%,100% 5%,100% 93%,19.2% 100%,19% 84%,0 84%);clip-path:polygon(0 0,86% 3%,86% 6%,100% 5%,100% 93%,19.2% 100%,19% 84%,0 84%)}";
const _23 = "._85i51epz{-webkit-padding-after:var(--ds-space-1000,5pc);padding-block-end:var(--ds-space-1000,5pc)}";
const _22 = "._1q51xncg{-webkit-padding-before:var(--ds-space-800,4pc);padding-block-start:var(--ds-space-800,4pc)}";
const _21 = "._1pbykb7n{z-index:1}";
const _20 = "._p12f1git{max-width:90pc}";
const _19 = "._11q711bn{background:var(--ds-background-accent-gray-subtlest,#f1f2f4)}";
const _18 = "._18m915vq{overflow-y:hidden}";
const _17 = "._1reo15vq{overflow-x:hidden}";
const _16 = "._18u01wug{margin-left:auto}";
const _15 = "._otyridpf{margin-bottom:0}";
const _14 = "._2hwx1wug{margin-right:auto}";
const _13 = "._19pkidpf{margin-top:0}";
const _12 = "@media (min-width:64rem){._40tu1epz{-webkit-padding-after:var(--ds-space-1000,5pc);padding-block-end:var(--ds-space-1000,5pc)}}";
const _11 = "._kqswh2mm{position:relative}";
const _10 = "@media (min-width:48rem) and (max-width:63.99rem){._em6nh2mm{position:relative}._j0lc1lo2 img{width:160%}._1jtm1wug img{height:auto}}";
const _9 = "@media not all and (min-width:48rem){._13zmh2mm{position:relative}._1h8e1pv1 img{width:140%}._1ga51wug img{height:auto}}";
const _8 = "._bna71wug img{height:auto}";
const _7 = "._mezj1osq img{width:100%}";
const _6 = "._4t3i4o5j{height:360.804px}";
const _5 = "._1bsbzih3{width:353.337px}";
const _4 = "._1h1t1ekt{aspect-ratio:1/1}";
const _3 = "._152txard{inset-block-start:-7%}";
const _2 = "._1e02idpf{inset-inline-start:0}";
const _ = "._kqswstnw{position:absolute}";
export const easeOutQuad = t => t * (2 - t);
export const frameDuration = 1000 / 60;
export const AnimateCount = _ref => {
  let {
    children = '0',
    duration = 2000
  } = _ref;
  const countTo = parseInt(children, 10);
  const [count, setCount] = useState(0);
  useEffect(() => {
    let frame = 0;
    const totalFrames = Math.round(duration / frameDuration);
    const counter = setInterval(() => {
      frame++;
      const progress = easeOutQuad(frame / totalFrames);
      setCount(countTo * progress);
      if (frame === totalFrames) {
        clearInterval(counter);
      }
    }, frameDuration);
    return () => clearInterval(counter);
  }, [countTo, duration]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: Math.floor(count).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  });
};

// Picture component does not accept compiled CSS. Using nested selector to apply CSS to displayed image.
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */
const statsImageStyles = null;
const defaultTextColor = null;
export const renderStatValue = (stat, isVisible) => {
  if (isVisible && !isNaN(Number(stat))) {
    return /*#__PURE__*/_jsx(AnimateCount, {
      children: stat
    });
  }
  return stat;
};
const StatsImage = _ref2 => {
  let {
    src
  } = _ref2;
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6, _7, _8, _9, _10]
    }), /*#__PURE__*/_jsx("div", {
      className: ax(["_kqswstnw _1e02idpf _152txard _1h1t1ekt _1bsbzih3 _4t3i4o5j _mezj1osq _bna71wug _13zmh2mm _1h8e1pv1 _1ga51wug _em6nh2mm _j0lc1lo2 _1jtm1wug"]),
      children: /*#__PURE__*/_jsx("img", {
        src: src,
        alt: "Statistics visualization"
      })
    })]
  });
};
const statsStyles = null;
const containerStyles = null;
const wrapperStyles = null;
const textWrapperStyles = null;
const mainContentStyles = null;
const headerStyles = null;
const statStyles = null;
const bigStatStyles = null;
const littleStatStyles = null;
const statTextStyles = null;
const statsGridStyles = null;
const statWrapperStyles = null;
const dividerStyles = null;
const statsSectionWrapperStyles = null;
const imageContainerStyles = null;
const desktopImageContainerStyles = null;
export const StatsSection = statsProps => {
  var _statsProps$bigStat$s;
  const [isVisible, setIsVisible] = useState(false);
  const {
    ref,
    inView
  } = useInView({
    threshold: 0.1,
    triggerOnce: true
  });
  useEffect(() => {
    if (inView) {
      setIsVisible(true);
    }
  }, [inView]);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_11, _12]
    }), /*#__PURE__*/_jsxs("div", {
      className: ax(["_kqswh2mm _40tu1epz"]),
      children: [/*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_13, _14, _15, _16, _17, _18, _19, _20, _11, _21, _22, _23, _24, _25, _26]
        }), /*#__PURE__*/_jsx("div", {
          ref: ref,
          className: ax(["_19pkidpf _2hwx1wug _otyridpf _18u01wug _1reo15vq _18m915vq _11q711bn _p12f1git _kqswh2mm _1pbykb7n _1q51xncg _85i51epz _mkrz13pj _1kmxidpf _1ggmidpf _1ykzidpf _1maeidpf _1vthtfdx _srwz1jfw _h15ztfdx _qtem1jfw"]),
          children: /*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_13, _14, _15, _16, _27, _28]
            }), /*#__PURE__*/_jsx("div", {
              className: ax(["_19pkidpf _2hwx1wug _otyridpf _18u01wug _1yt410dx _p12f1fra"]),
              style: {
                "--_vzwnpz": ix("0 ".concat("var(--ds-space-250, 20px)"))
              },
              children: /*#__PURE__*/_jsxs(CC, {
                children: [/*#__PURE__*/_jsx(CS, {
                  children: [_29, _30, _31, _32, _33]
                }), /*#__PURE__*/_jsxs("div", {
                  className: ax(["_1e0c1txw _1q51v47k _85i5v47k _1gde1bp4 _55br1bp4"]),
                  children: [/*#__PURE__*/_jsxs(CC, {
                    children: [/*#__PURE__*/_jsx(CS, {
                      children: [_34, _35, _36, _29, _37, _11, _38, _39, _40]
                    }), /*#__PURE__*/_jsxs("div", {
                      className: ax(["_zulp1jfw _1q51xy5q _p12f1osq _1e0c1txw _4cvr1y6m _kqswh2mm _1t19idpf _p7vbidpf _1rhg1w8u _19wgv47k _1gde1bp4 _1u2qoahv _1os2idpf _8os5idpf _16xt1osq _1gzv1ejb"]),
                      children: [/*#__PURE__*/_jsxs(CC, {
                        children: [/*#__PURE__*/_jsx(CS, {
                          children: [_41, _42, _43, _44]
                        }), /*#__PURE__*/_jsxs("div", {
                          className: ax(["_16jlkb7n _1o9zkb7n _i0dl1ssb _1fe7kb7n _12ihkb7n _1a1xf1ug _1rfm1osq"]),
                          children: [/*#__PURE__*/_jsxs(CC, {
                            children: [/*#__PURE__*/_jsx(CS, {
                              children: [_13, _45, _15, _46]
                            }), /*#__PURE__*/_jsx(H2, {
                              className: ax(["_19pkidpf _2hwxidpf _otyridpf _18u0idpf"]),
                              children: statsProps.headerText
                            })]
                          }), /*#__PURE__*/_jsxs(CC, {
                            children: [/*#__PURE__*/_jsx(CS, {
                              children: [_47, _48, _49, _50, _11, _51, _52, _53, _54]
                            }), /*#__PURE__*/_jsxs("p", {
                              className: ax(["_18s8pn2k _ect41roz _k48p9y44 _vwz4kb7n _kqswh2mm _syaz1e6v", "_1wyb1lev _1cqs1k7u _1lzo12bs"]),
                              style: {
                                "--_senhmo": ix("var(--ds-space-150, 12px)".concat(" 0 ", "var(--ds-space-100, 8px)"))
                              },
                              children: [/*#__PURE__*/_jsxs(CC, {
                                children: [/*#__PURE__*/_jsx(CS, {
                                  children: [_51]
                                }), /*#__PURE__*/_jsx("span", {
                                  style: {
                                    color: statsProps.bigStat.statColor
                                  },
                                  className: ax(["_syaz1e6v"]),
                                  children: renderStatValue(statsProps.bigStat.stat, isVisible)
                                })]
                              }), ((_statsProps$bigStat$s = statsProps.bigStat.statSymbol) === null || _statsProps$bigStat$s === void 0 ? void 0 : _statsProps$bigStat$s.symbolCharacter) && /*#__PURE__*/_jsxs(CC, {
                                children: [/*#__PURE__*/_jsx(CS, {
                                  children: [_51]
                                }), /*#__PURE__*/_jsx("span", {
                                  style: {
                                    color: statsProps.bigStat.statSymbol.symbolCharacterColor
                                  },
                                  className: ax(["_syaz1e6v"]),
                                  children: statsProps.bigStat.statSymbol.symbolCharacter
                                })]
                              })]
                            })]
                          }), /*#__PURE__*/_jsxs(CC, {
                            children: [/*#__PURE__*/_jsx(CS, {
                              children: [_13, _45, _15, _46, _55, _56, _57, _58]
                            }), /*#__PURE__*/_jsx("p", {
                              className: ax(["_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wyb1j6v _k48p1nn1 _vwz419ii _syaz1fxt"]),
                              children: statsProps.bigStat.statText
                            })]
                          })]
                        })]
                      }), /*#__PURE__*/_jsxs(CC, {
                        children: [/*#__PURE__*/_jsx(CS, {
                          children: [_41, _42, _59, _60, _29, _61, _62, _63]
                        }), /*#__PURE__*/_jsx("div", {
                          className: ax(["_16jlkb7n _1o9zkb7n _i0dl1r5k _zulpv47k _1e0c1txw _2lx21bp4 _y4ti1jfw _1fe7kb7n _12ihkb7n _1a1xf1ug _chtuidpf"]),
                          children: statsProps.littleStats.map((statObj, index) => {
                            var _statObj$statSymbol;
                            return /*#__PURE__*/_jsxs(CC, {
                              children: [/*#__PURE__*/_jsx(CS, {
                                children: [_11, _64]
                              }), /*#__PURE__*/_jsxs("div", {
                                className: ax(["_kqswh2mm _bozgv47k"]),
                                children: [/*#__PURE__*/_jsxs(CC, {
                                  children: [/*#__PURE__*/_jsx(CS, {
                                    children: [_65, _, _2, _66, _67]
                                  }), /*#__PURE__*/_jsx("div", {
                                    className: ax(["_11q71fxt _kqswstnw _1e02idpf _1bsbyh40 _4t3i1osq"])
                                  })]
                                }), /*#__PURE__*/_jsxs(CC, {
                                  children: [/*#__PURE__*/_jsx(CS, {
                                    children: [_47, _48, _49, _50, _11, _51, _68]
                                  }), /*#__PURE__*/_jsx("p", {
                                    className: ax(["_18s8pn2k _ect41roz _k48p9y44 _vwz4kb7n _kqswh2mm _syaz1e6v", "_1wyb1wto"]),
                                    style: {
                                      "--_senhmo": ix("var(--ds-space-150, 12px)".concat(" 0 ", "var(--ds-space-100, 8px)"))
                                    },
                                    children: /*#__PURE__*/_jsxs(CC, {
                                      children: [/*#__PURE__*/_jsx(CS, {
                                        children: [_51]
                                      }), /*#__PURE__*/_jsxs("span", {
                                        style: {
                                          color: statObj.statColor
                                        },
                                        className: ax(["_syaz1e6v"]),
                                        children: [renderStatValue(statObj.stat, isVisible), ((_statObj$statSymbol = statObj.statSymbol) === null || _statObj$statSymbol === void 0 ? void 0 : _statObj$statSymbol.symbolCharacter) && /*#__PURE__*/_jsxs(CC, {
                                          children: [/*#__PURE__*/_jsx(CS, {
                                            children: [_51]
                                          }), /*#__PURE__*/_jsx("span", {
                                            style: {
                                              color: statObj.statSymbol.symbolCharacterColor
                                            },
                                            className: ax(["_syaz1e6v"]),
                                            children: statObj.statSymbol.symbolCharacter
                                          })]
                                        })]
                                      })]
                                    })
                                  })]
                                }), /*#__PURE__*/_jsxs(CC, {
                                  children: [/*#__PURE__*/_jsx(CS, {
                                    children: [_13, _45, _15, _46, _55, _56, _57, _58]
                                  }), /*#__PURE__*/_jsx("p", {
                                    className: ax(["_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wyb1j6v _k48p1nn1 _vwz419ii _syaz1fxt"]),
                                    children: statObj.statText
                                  })]
                                })]
                              }, index)]
                            }, index);
                          })
                        })]
                      })]
                    })]
                  }), /*#__PURE__*/_jsxs(CC, {
                    children: [/*#__PURE__*/_jsx(CS, {
                      children: [_11, _29, _69, _70, _67, _71, _72, _73, _74, _75, _76]
                    }), /*#__PURE__*/_jsx("div", {
                      className: ax(["_kqswh2mm _1e0c1txw _1bah1h6o _1h1tgbua _4t3i1osq _rjxpidpf _u7coidpf _152tidpf _tnrudlvw _476d1jfw _srwzidpf _ag851y6m _1vkh68cl _98081jfw _qtemidpf _19vu1y6m _dm25glyw"]),
                      children: /*#__PURE__*/_jsx(StatsImage, {
                        src: statsProps.image
                      })
                    })]
                  })]
                })]
              })
            })]
          })
        })]
      }), /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_77, _78]
        }), /*#__PURE__*/_jsx("div", {
          className: ax(["_1e0cglyw _dm251ule _13wnstnw _hyzqcs5v _gltezih3 _165t4o5j _bb41gbua _1t06utlk _180kdx5h"]),
          style: {
            "--_3j0cp8": ix("calc(".concat("var(--ds-space-800, 64px)", " + 130px)"))
          },
          children: /*#__PURE__*/_jsx(StatsImage, {
            src: statsProps.image
          })
        })]
      })]
    })]
  });
};
export default StatsSection;